<template>
  <div class="tooltip-element ml-2">
    <b-popover
      :target="ID"
      triggers="focus"
      placement="right"
      container="my-container"
      custom-class="vkeyboardFloatContainer"
      ref="popover"
    >
      <div class="keyboard-icon" @click.prevent.stop="onClickFun"></div>
    </b-popover>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    onClickFun: {
      type: Function,
    },
    ID: {
      type: String,
      default: 'keyboard-float',
    },
    classname: {
      type: String,
      default: ""
    }
  },
  methods: {
  }
};
</script>

<style>

.vkeyboardFloatContainer .popover-body {
    padding: 0rem 0.4rem!important;
}

.tooltip-element {
    cursor: pointer;
}
 
</style>










// WEBPACK FOOTER //
// src/components/Partials/keyboardFloatingToggle.vue